import React, { ReactElement, useRef, useState } from 'react';
import { Crypto } from '@sensechat/crypto-interceptor/key'
import { Layout, Button, theme, Input, Space, message } from 'antd';
import styles from './index.module.scss'
const { TextArea } = Input;

const { Header, Content, Footer } = Layout;

const Content1: React.FC = () => {
  const {
    token: { colorBgContainer, borderRadiusLG },
  } = theme.useToken();

  const [decryptInput, setDecryptInput] = useState<string>('')
  const [decryptOutput, setDecryptOutput] = useState<string>('')
  const [encryptInput, setEncryptInput] = useState<string>('')
  const [encryptOutput, setEncryptOutput] = useState<string>('')

  const handleDecrypt = () => {
    Crypto.decrypt(decryptInput.trim()).then((data)=> {
      setDecryptOutput(data ?? '')
    }).catch((error) => message.info('操作失败'))
  }
  const handleEncrypt = () => {
    Crypto.encrypt(JSON.stringify(encryptInput.trim())).then((data)=> {
      setEncryptOutput(data?? '')
    }).catch((error) => message.info('操作失败'))
  }


  return (
    <div className={styles.container}>
      <TextArea className={styles.textArea} onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => setDecryptInput(e.target.value)} rows={5} placeholder="请输入需要解密的数据"  />
      <Button className={styles.button} type="primary" onClick={handleDecrypt}>解密</Button>
      <div className={styles.text}>{decryptOutput}</div>
      <TextArea className={styles.textArea} onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => setEncryptInput(e.target.value)} rows={5} placeholder="请输入需要加密的数据" />
      <Button className={styles.button}  type="primary"  onClick={handleEncrypt}>加密</Button>
      <div className={styles.text}>{encryptOutput}</div>
    </div>
  );
};

export default Content1;
